import React from 'react';
import MovementListing from "../MovemenListing";
import InstallationTab from './InstallationTab';
import CapVendaTab from './CapVendaTab';
import { withRouter, Link, Route } from 'react-router-dom'
import ContaTabs from '../ContaTabs'

class MovementTabsContainer extends React.Component {

    render() {
        return (
            <div className="mt-4">
                <ContaTabs search={this.props.location.search} date={new Date()} />
                <ul className="nav nav-tabs tab-container">
                    <li className="nav-item">
                        <Link className={`nav-link p-3 border ${this.props.location.pathname.includes('movementlist') ? 'active' : 'bg-white text-body'}`} to={{ pathname: 'movementlist', search: this.props.location.search }}><span className="k-icon k-i-menu"></span>&nbsp;Movimentos</Link>
                    </li>
                    <li className="nav-item">
                        <Link className={`nav-link p-3 border ${this.props.location.pathname.includes('movementrecord') ? 'active' : 'bg-white text-body'}`} to={{ pathname: 'movementrecord', search: this.props.location.search }}><span className="k-icon k-i-menu"></span>&nbsp;Registo</Link>
                    </li>
                    <li className="nav-item">
                        <Link className={`nav-link p-3 border ${this.props.location.pathname.includes('movementhistory') ? 'active' : 'bg-white text-body'}`} to={{ pathname: 'movementhistory', search: this.props.location.search }}><span className="k-icon k-i-menu"></span>&nbsp;Hist&#xF3;rico do Registo</Link>
                    </li>
                </ul>
                <div className="table-section custom-k-grid pt-3">
                    <div className="table-responsive">
                        <Route path={`${this.props.match.path}/movementlist`} component={MovementListing} />
                        <Route path={`${this.props.match.path}/movementrecord`} component={InstallationTab} />
                        <Route path={`${this.props.match.path}/movementhistory`} component={CapVendaTab} />
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(MovementTabsContainer);
